// useBackWithinFlow.ts  (replace existing contents)
import { useEffect } from "react";
import { NavigateTo, SetLocation } from "@/helper/navigation";

export function useBackWithinFlow(onExit: () => void, tenant?: string) {
    const tenantify = (path: string) => {
        const clean = path.replace(/^\/+/, "");
        return tenant ? `/${tenant}/${clean}` : `/${clean}`;
    };

    const getStepFromUrl = () => {
        const s = new URLSearchParams(window.location.search).get("step") ?? "0";
        const n = Number(s);
        return Number.isFinite(n) && n >= 0 ? n : 0;
    };

    useEffect(() => {
        // sync current URL (no arming push)
        const url = NavigateTo({ cancel: false });
        history.replaceState({ step: getStepFromUrl() }, "", tenantify(url));

        const onPop = () => {
            const step = getStepFromUrl();

            // consume back INSIDE the flow by replacing (no extra entries)
            if (step > 0) {
                const prev = step - 1;
                SetLocation(prev);
                const urlPrev = NavigateTo({ cancel: false });
                history.replaceState({ step: prev }, "", tenantify(urlPrev));
                // react-router picks up URL change; if you need, you can force navigate here with {replace:true}
                return;
            }

            // step === 0 → exit once, no re-arming, no extra push
            onExit();
        };

        window.addEventListener("popstate", onPop);
        return () => window.removeEventListener("popstate", onPop);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onExit, tenant]);
}
